import css from './GSEventBoxSkeleton.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_MEDIUMGREY } from 'utils/constants/colors'

const GSEventBoxSkeleton: React.FC = () => {
  return (
    <div className={css.eventBox}>
      <div className={css.title}>
        <Skeleton
          className={css.content_skeleton}
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={8}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          height={40}
        />
      </div>
    </div>
  )
}

export default GSEventBoxSkeleton
